<template>
  <b-card no-body>
    <b-card-body>
      <customer-user-detail
        ref="customerUserDetail"
        type="new"
        :submitting="submitting"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import CustomerUserDetail from '@/views/pages/customers/CustomerUserDetail.vue';

export default {
  components: {
    BCard,
    BCardBody,
    CustomerUserDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      data: {}
    };
  },
  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .createUser(data)
        .then(response => {
          this.$refs.customerUserDetail.resetForm();
          this.$router.push('/');
          this.showSuccessMessage(`${response.message}`);
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
